module.exports = __webpack_public_path__ + "static/media/Koushik.247b8f6c.png";